const feedBack = {
    order_chat: 1,   // 订单沟通
    clue_chat: 11,  // 线索沟通
    com_chat: 16,  // 公司沟通
    customer_chat: 17,  // 客户沟通
    fee_chat: 18,  // 续费沟通
    order_service: 19,  // 订单服务
    pending_matter: 21,  // 待办事项
    post_matter: 22,  // 快递事项
    refund_chat: 27,   // 退款沟通
    unpay_order: 29,   // 未支付订单
};

export default feedBack;


// WEBPACK FOOTER //
// ./src/lib/feedBack.js